export default "__VITE_ASSET__CMaTJV4M__"